import * as z from 'zod';

import { nullableNumericMutationSchema } from '@/_schemas/generic';

import { companyQuerySchema } from './company-query-schema';

export const companyUpdateSchema = companyQuerySchema
  .omit({
    logo: true,
    status: true,
    brand: true,
    account_manager: true,
    partner: true,
    relationship_score: true,
    audience: true,
    organization_type: true,
    billing_system: true,
    billing_term: true,
    industries: true,
    magazine: true,
    phone_numbers: true,
    year_established: true,
    timezone_id: true,
    contacts_count: true,
    contacts: true,
    domains: true,
    addresses: true,
    primary_contact: true,
    agreements: true,
    marketing_campaigns: true,
    all_gnt_affiliations: true,
    all_non_gnt_affiliations: true,
    primary_subsidiaries: true,
  })
  .extend({
    logo: z.array(z.number()),
    phone_numbers: z.array(z.number()),
    status: z.string(),
    year_established: z.number().nullable(),
    domains: z.array(z.number()),
    addresses: z.array(z.number()),
    industries: z.array(z.number()),
    gnt_affiliations: z.array(z.number()),
    non_gnt_affiliations: z.array(z.number()),
    primary_contact: z.array(z.number()),
    alternate_contacts: z.array(z.number()),
    subsidiaries: z.array(z.number()),
    primary_subsidiaries: z.array(z.number()),

    harvest: nullableNumericMutationSchema(),
    box: nullableNumericMutationSchema(),
    freshdesk: nullableNumericMutationSchema(),
  });

export type CompanyUpdateSchema = z.infer<typeof companyUpdateSchema>;

export const companyCreateSchema = companyUpdateSchema.pick({
  name: true,
  short_name: true,
  status: true,
});

export type CompanyCreateSchema = z.infer<typeof companyCreateSchema>;
